import Immutable from 'immutable';

// constants
import {
  BOOK_FOLLOW,
  BOOK_UNFOLLOW,
  BOOKS_FETCH,
  BOOKS_SHOW,
  BOOKS_FETCH_CATERERS,
  BOOKS_LIST_CLEAR,
  BOOKS_SEARCH
} from '../constants/booksTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { callbackHandler, merge, replace } from '../lib/mapReducerHelpers';

const addCaterersToBook = function(state, action) {
  const payload = action.payload || {};
  const items   = payload.items || [];

  let newState  = state;
  let newData   = state.get('data') || Immutable.Map();

  if (payload.officeId) {
    newState = newState.set('result', Immutable.List().push(payload.officeId));
  } else {
    const officeId = (newState.get('result') || Immutable.List()).get(0);
    const newBook  = newData.get(officeId) || Immutable.Map();

    newData = newData.set(officeId, newBook.set('caterers', Immutable.fromJS(items)));
  }

  return newState.set('data', newData);
};

const show = function(map, action) {
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const entity      = entities.book || {};
  const book = entity[normalized.result];
  let newBook = Immutable.Map();

  if (book) {
    newBook  = newBook.set(book.id, Immutable.fromJS(book));
  }
  return map.set('data', newBook);
};

const setFollowStatus = function(state, action) {
  const payload = action.payload || {};

  if (payload.id) {
    return state.setIn(['data', payload.id, 'followed'], payload.followed);
  }
  return state;
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case BOOKS_FETCH:             return httpReducer(state, action, callbackHandler(merge, 'book'));
    case BOOKS_FETCH_CATERERS:    return httpReducer(state, action, addCaterersToBook);
    case BOOKS_SHOW:              return httpReducer(state, action, show);
    case BOOKS_LIST_CLEAR:        return Immutable.Map();
    case BOOK_FOLLOW:             return httpReducer(state, action, setFollowStatus);
    case BOOK_UNFOLLOW:           return httpReducer(state, action, setFollowStatus);
    case BOOKS_SEARCH:            return httpReducer(state, action, callbackHandler(merge, 'book'));
    default:                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/books.js